export const getContentDispositionFileName = (str: string): string => {
  const fileNameRegExp = /\"([^)]+)\"/;
  if (!!str) {
    const name = fileNameRegExp.exec(str);
    return decodeURI(name[1]);
  }
  return null;
};
